import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GroupGamesService } from 'src/app/services/group-games.service';
import { DuelSeriesViewComponent } from '../duel-series-view/duel-series-view.component';
import { DuelSeriesService } from 'src/app/services/duel-series.service';
import {DuelViewsServiceService} from "../../services/duel-views-service.service";

@Component({
  selector: 'app-group-game',
  templateUrl: './group-game.component.html',
  styleUrls: ['./group-game.component.scss']
})
export class GroupGameComponent implements OnInit {

  @Input() score: string = '';
  @Input() playerOneNumber: number = -1;
  @Input() playerTwoNumber: number = -1;
  @Input() groupId: number = -1;
  @Input() duelSeriesId: number = -1;
  @Input() status: string = '';

  public highlighted: boolean = false;

  constructor(
    private groupGamesService: GroupGamesService,
    private modalService: NgbModal,
    private duelSeriesService: DuelSeriesService,
    private duelViewService: DuelViewsServiceService,
  ) { }

  ngOnInit(): void {
    this.groupGamesService.highlightGameEmitter.subscribe((event) => {
      if (event.event == 'off') {
        this.highlighted = false;
      } else if (event.event == 'on' && event.players.indexOf(this.playerOneNumber) > -1 && event.players.indexOf(this.playerTwoNumber) > -1) {
        this.highlighted = true;
      } else if (event.event == 'update_score') {
        if (
          (event.players[0] == this.playerOneNumber && event.players[1] == this.playerTwoNumber)
        ) {
          this.score = `${event[this.playerOneNumber]} : ${event[this.playerTwoNumber]}`;
        }
      } else if (event.event == 'update_status') {
        if (
          (event.players[0] == this.playerOneNumber && event.players[1] == this.playerTwoNumber)
        ) {
          this.status = event.status;
        }
      }
    });
  }

  mouseEnter($event: MouseEvent) {
    this.groupGamesService.hover(this.playerOneNumber, this.playerTwoNumber);
  }

  mouseLeave($event: MouseEvent) {
    this.groupGamesService.leave(this.playerOneNumber, this.playerTwoNumber);
  }

  open() {
    const modalRef = this.modalService.open(DuelSeriesViewComponent, {
      size: 'lg'
    });
    this.duelViewService.duelId = this.duelSeriesId;
    // modalRef.componentInstance.id = this.duelSeriesId;
    modalRef.result.then(() => {
      this.updateScore(modalRef.componentInstance.duelSeries);
    }, () => {
      this.updateScore(modalRef.componentInstance.duelSeries);
    });
  }

  updateScore(duelSeries: any) {
    if (duelSeries.player_one.id == this.playerOneNumber) {
      this.score = `${duelSeries.player_one_score} : ${duelSeries.player_two_score}`;
      this.groupGamesService.updateScore(this.playerTwoNumber, this.playerOneNumber, duelSeries.player_two_score, duelSeries.player_one_score);
    } else {
      this.score = `${duelSeries.player_two_score} : ${duelSeries.player_one_score}`;
      this.groupGamesService.updateScore(this.playerTwoNumber, this.playerOneNumber, duelSeries.player_one_score, duelSeries.player_two_score);
    }
    if (this.status != duelSeries.status) {
      this.status = duelSeries.status;
      this.groupGamesService.updateStatus(this.playerTwoNumber, this.playerOneNumber, duelSeries.status)
    }
  }

}
